import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
const StarField = () => {
  const stars = Array.from({
    length: 40
  }, (_, i) => ({
    id: i,
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    size: Math.random() * 3 + 1,
    duration: Math.random() * 3 + 2,
    delay: Math.random() * 4
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-82">
      {stars.map(star => <div key={star.id} className="absolute rounded-full bg-gold-300 star" style={{
      top: star.top,
      left: star.left,
      width: star.size,
      height: star.size,
      '--duration': `${star.duration}s`,
      '--delay': `${star.delay}s`
    } as React.CSSProperties} data-id="element-83" />)}
    </div>;
};
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-navy-900 px-4 py-16" data-id="element-84">
      <StarField data-id="element-85" />

      {/* Radial glow behind content */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-86">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-10" style={{
        background: 'radial-gradient(circle, #c9a84c 0%, transparent 70%)'
      }} data-id="element-87" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-88">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold-500/40 bg-gold-500/10 text-gold-300 text-sm font-lato font-bold tracking-widest uppercase mb-8" data-id="element-89">
          Guía 2026 · Validada por Miles de Familias Hispanas
        </motion.div>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-90">
          <span className="gold-gradient-text" data-id="element-91">¿Privación del Sueño</span>
          <br data-id="element-92" />
          <span className="text-cream" data-id="element-93">o Tortura?</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-lato text-xl md:text-2xl text-cream/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-94">
          La guía para padres que ya no pueden más — el método respetuoso para
          que tu bebé duerma{' '}
          <span className="text-gold-300 font-bold" data-id="element-95">7 horas seguidas</span>, sin
          dejarlo llorar.
        </motion.p>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.5
      }} className="float-animation mb-10 mx-auto max-w-sm md:max-w-md" data-id="element-96">
          <div className="relative" data-id="element-97">
            <div className="absolute inset-0 rounded-2xl opacity-40 blur-2xl" style={{
            background: 'radial-gradient(circle, #c9a84c, transparent)'
          }} data-id="element-98" />
            <img src="https://cdn.magicpatterns.com/uploads/d5HYHU22Kw6rTjYdAWsyEM/private_openrouter-generated-image-1771628231678.png" alt="El Método Sueño Profundo - Guía Digital" className="relative z-10 w-full drop-shadow-2xl" data-id="element-99" />
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-100">
          <button onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} className="cta-glow gold-gradient-bg text-navy-900 font-lato font-black text-lg md:text-xl px-10 py-5 rounded-full uppercase tracking-wide hover:scale-105 transition-transform duration-200 cursor-pointer" data-id="element-101">
            QUIERO RECUPERAR MIS NOCHES →
          </button>

          <div className="flex flex-wrap items-center justify-center gap-4 mt-5 text-cream/60 font-lato text-sm" data-id="element-102">
            {['Acceso inmediato', 'Garantía 7 días', 'Solo $6.39 USD'].map(item => <span key={item} className="flex items-center gap-1" data-id="element-103">
                  <Check size={14} className="text-gold-400" data-id="element-104" />
                  {item}
                </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}